import React from 'react'

export const THEMES = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
}

export const ThemeContext = React.createContext(THEMES.DARK)